<template>
  <highcharts :options="options" />
</template>

<script>
import '@/plugins/highcharts.js'

/* function addPointsBetween (twoPoints) {
  const newPoint = (twoPoints[0] + twoPoints[1]) / 2
  const threePoints = [twoPoints[0], newPoint, twoPoints[1]]
  return threePoints
} */

export default {
  name: 'ScenarioArea',
  props: {
    ghgi: {
      type: Object,
      default: function () {
        return {}
      }
    },
    scenario: {
      type: Object,
      default: function () {
        return {}
      }
    },
    modules: {
      type: Array,
      default: function () {
        return []
      }
    },
    colors: {
      type: Object
    },
    height: {
      type: Number,
      default: 400
    },
    exporting: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    categories: function () {
      return [this.ghgi.year, this.scenario.timeline]
    },
    series: function () {
      let series = []
      for (let module of this.modules) {
        let gintensity = this.ghgi.carbonSynthesis[module].intensity / 1000
        let sintensity = this.scenario.carbonSynthesis[module].intensity / 1000
        series.push({
          name: this.$t(module),
          data: [gintensity, sintensity],
          color: this.colors[module]
        })
      }
      // add intermediate points
      /* series.map(serie => {
        let newData = addPointsBetween([serie.data[0], serie.data[1]])
        serie.data = newData
      }) */
      return series
    },
    options: function () {
      return {
        title: {
          text: ''
        },
        chart: {
          height: this.height,
          type: 'area'
        },
        exporting: {
          enabled: this.exporting
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          area: {
            stacking: 'normal'
          }
        },
        tooltip: {
          valueSuffix: ' ' + this.$t('t.co2e'),
          valueDecimals: 2,
          shared: true
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: this.categories,
          maxPadding: 0,
          min: 0.45,
          max: 0.55
        },
        series: this.series
      }
    }
  }
}
</script>
